import { render } from "./NowPlayingMovie.vue?vue&type=template&id=3d9bec3b&scoped=true"
import script from "./NowPlayingMovie.vue?vue&type=script&lang=js"
export * from "./NowPlayingMovie.vue?vue&type=script&lang=js"

import "./NowPlayingMovie.vue?vue&type=style&index=0&id=3d9bec3b&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d9bec3b"]])

export default __exports__